import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "v-home" }

import { ref } from "vue";
import { useHead } from "@vueuse/head";

import VsHomeHeader from "@/views/home/header.vue";
import VsHomeServices from "@/views/home/services.vue";
import VsHomeSolutions from "@/views/home/solutions.vue";
import VsHomeSignature from "@/views/home/signature.vue";
import VsHomeHowItWorks from "@/views/home/how-it-works.vue";
import VsHomeComments from "@/views/home/comments.vue";
import VsHomeBePartOfIt from "@/views/home/be-part-of-it.vue";
import VsHomeContact from "@/views/home/contact.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

useHead({ title: "Agende suas consultas, exames e procedimentos | obmed" });

const selectedSolution = ref<"services" | "signature" | "financing">("services");

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(VsHomeHeader),
    _createVNode(VsHomeSolutions, {
      "onSelect:card": _cache[0] || (_cache[0] = (solution) => (selectedSolution.value = solution))
    }),
    (selectedSolution.value === 'services')
      ? (_openBlock(), _createBlock(VsHomeServices, { key: 0 }))
      : _createCommentVNode("", true),
    (selectedSolution.value === 'signature')
      ? (_openBlock(), _createBlock(VsHomeSignature, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(VsHomeHowItWorks),
    _createVNode(VsHomeComments),
    _createVNode(VsHomeBePartOfIt),
    _createVNode(VsHomeContact),
    _createVNode(_component_router_view)
  ]))
}
}

})